import barba from '@barba/core';

const cursor = document.querySelector(".custom-cursor");

const iconMapping = {
	arrowi: ".swiper-prev",
	arrow: ".swiper-next",
};

const setCursorSizeHandler = (enlarged) => {
	return ((enlarged) => {
		if (enlarged) {
			cursor.classList.add("custom-cursor--is-enlarged");
		} else {
			cursor.classList.remove("custom-cursor--is-enlarged");
		}
	}).bind(null, enlarged);
};

const setCursorIconHandler = (icon) => {
	return ((icon) => {
		cursor.classList.forEach((className) => {
			if (className.startsWith("custom-cursor--icon-")) {
				cursor.classList.remove(className);
			}
		});
		if (icon) {
			cursor.classList.add("custom-cursor--icon-" + icon);
		}
	}).bind(null, icon)
};

const setCursorTextHandler = (text) => {
	return ((text) => {
		if (text) {
			cursor.classList.add("custom-cursor--is-text");
			cursor.querySelector(".custom-cursor__text").innerHTML = text;
		} else {
			cursor.classList.remove("custom-cursor--is-text");
			cursor.querySelector(".custom-cursor__text").innerHTML = '';
		}
	}).bind(null, text);
};

const initCustomCursor = () => {

	window.cursorPosition = {
		x: -100,
		y: -100,
	};

	const updateCursorPosition = (e) => {
		window.cursorPosition = {
			x: e.clientX,
			y: e.clientY,
		};
	};

	const moveCursor = () => {
		cursor.style.transform = `translate3d(${window.cursorPosition.x}px, ${window.cursorPosition.y}px, 0)`;
	};

	document.addEventListener('mousemove', updateCursorPosition, { passive: true });
	document.addEventListener('mousemove', () => { cursor.classList.add("custom-cursor--initialized") }, { passive: true, once: true });
	setInterval(moveCursor, 10);

};

export const initCursorElements = (container = document) => {
	// Size change
	container.querySelectorAll("a, button, .swiper-prev, .swiper-next, .swiper-pagination-bullet, .footer__tooltip, .accordion__header").forEach(function (el) {
		el.addEventListener("mouseenter", setCursorSizeHandler(true), { passive: true });
		el.addEventListener("mouseleave", setCursorSizeHandler(false), { passive: true });
	});
	// Icon change
	for (const [icon, selector] of Object.entries(iconMapping)) {
		container.querySelectorAll(selector).forEach(function (el) {
			el.addEventListener("mouseenter", setCursorIconHandler(icon), { passive: true });
			el.addEventListener("mouseleave", setCursorIconHandler(false), { passive: true });
		});
	}
	// Cursor text
	container.querySelectorAll("[data-cursor-text]").forEach(function (el) {
		el.addEventListener("mouseenter", setCursorTextHandler(el.dataset.cursorText), { passive: true });
		el.addEventListener("mouseleave", setCursorTextHandler(false), { passive: true });
	});
};

document.addEventListener("DOMContentLoaded", initCustomCursor);

document.addEventListener("DOMContentLoaded", () => { initCursorElements(); });
barba.hooks.beforeEnter((data) => { initCursorElements(data.next.container) });
